<template>
  <div class="upload-queue">
    <p>
    Drag and drop files to your browser window.<br>
    Or browse for files on your computer.<br>
    <input type="file" multiple @input="fileChange" />
    </p>
    <button class="upload" @click.prevent="startUpload" :disabled="uploads.length == 0">Start Upload</button>
    <table v-if="uploads.length > 0">
      <thead>
        <tr>
          <th>Filename</th>
          <th>Size</th>
          <th><a href="#" class="remove-all" @click.prevent="removeAll">Remove All</a></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(file, index) in uploads" :key="index">
          <td>{{ file.name }}</td>
          <td>{{ file.size|clean_filesize }}</td>
          <td>
            <template v-if="!uploading">
              <a href="#" class="remove" @click.prevent="removeUpload(index)">Remove</a>
            </template>
            <template v-else>
              <progress  min=0 max=100 :value="uploadProgress[index]" />
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'

const allowed_types = /\.(jpg|jpeg|png|gif|webp|zip|gz|tar|docx|xlsx|xlsb|doc|xls|pptx|pdf|odf|tgz|rar|7z|mp4|webm|mkv|ogg|aac|mp3|csv|xml|xsl|xslt|xsd)$/i

export default {
  name: 'upload',
  props: ['value', 'maxFiles', 'path'],
  data () {
    return {
      uploads: [],
      uploading: false,
      structure: [],
      uploadProgress: [],
    }
  },
  computed: {
    canHandleFolders() {
      return false
      // return window.DataTransferItem !== undefined && window.DataTransferItem.prototype.webkitGetAsEntry !== undefined
    },
  },
  methods: {
    fileChange (event) {
      if (event.target.files.length > 0) {
        for (let i=0; i < event.target.files.length; i++) {
          let file = event.target.files[i]
          if (allowed_types.test(file.name)) {
            this.uploads.push(file)
            this.uploadProgress.push(0.0)
          }
        }

        event.target.value = null
      }
    },
    handleDrop (event) {
      event.stopPropagation();
      event.preventDefault();

      if (!event.dataTransfer) return;

      if (!this.canHandleFolders) {
        for (let f of event.dataTransfer.files) {
          if (allowed_types.test(f.name)) {
            this.uploads.push(f)
            this.uploadProgress.push(0.0)
          }
        }

        this.structure = []
      }
      else {
        for (let f of event.dataTransfer.files) {
          let entry = f.webkitGetAsEntry()

          // loop through entries
          // determine structure to build
          // determine which files go into that folder
        }
      }
    },
    handleDragEnterOver (event) {
      event.stopPropagation();
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    },
    handleDragLeave (event) {
      event.stopPropagation();
      event.preventDefault();
    },
    removeAll() {
      this.uploads = []
      this.uploadProgress = []
    },
    removeUpload (index) {
      this.uploads.splice(index, 1);
      this.uploadProgress.splice(index, 1)
    },
    async startUpload() {
      this.uploading = true;

      this.uploadProgress = this.uploads.map(_ => 0.0)

      var self = this
      let i = 0
      while (i < this.uploads.length) {

        let f = this.uploads[i]

        let data = new FormData()
        data.append('upload', f)
        data.append('folder', this.path)

        try {
          let res = await axios.post(`/api/files`, data, {
            onUploadProgress: (event) => {
              // this.$refs.progress.value = (event.loaded / event.total) * 100
              this.uploadProgress[i] = (event.loaded / event.total) * 100
            }
          })
        }
        catch (e) {
          // this.$notify.error('Error uploading item(s)', 2000)
          console.error(e)
          f._status = 'error'
          f._error = e
          uploadProgress.value[i] = 0.0
          i++;
          continue
        }

        i++;
        this.$emit('uploadcomplete', f)
      }

      this.$emit('finished')
      this.uploading = false;
      this.uploads = this.uploads.filter(i => i._status != '')
      this.uploadProgress = new Array(this.uploads.length)
    },
  },
  mounted () {
    document.addEventListener('drop', this.handleDrop)
    document.addEventListener('dragenter', this.handleDragEnterOver)
    document.addEventListener('dragover', this.handleDragEnterOver)
    document.addEventListener('dragleave', this.handleDragLeave)
  },
  filters: {
    clean_filesize (size) {
      let logbase = (num, base) => Math.log(num) / Math.log(base)

      let labels = ['B', 'KB', 'MB', 'GB', 'TB'];

      let index = Math.min(Math.floor(logbase(size, 1024)), labels.length);
      let short = size / Math.pow(1024, index);

      return short.toFixed() + labels[index];
    }
  },
  beforeDestroy () {
    document.removeEventListener('drop', this.handleDrop)
    document.removeEventListener('dragenter', this.handleDragEnterOver)
    document.removeEventListener('dragover', this.handleDragEnterOver)
    document.removeEventListener('dragleave', this.handleDragLeave)
  },
}
</script>
<style lang="scss">
button[disabled] {
    opacity: 0.5;
}
.remove-all {
  font-weight: normal;
  font-size: 90%;
}
</style>
